import { render, staticRenderFns } from "./DonateModal.vue?vue&type=template&id=18af9a59&scoped=true&"
import script from "./DonateModal.vue?vue&type=script&lang=js&"
export * from "./DonateModal.vue?vue&type=script&lang=js&"
import style0 from "./DonateModal.vue?vue&type=style&index=0&id=18af9a59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18af9a59",
  null
  
)

export default component.exports